import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const PhoneGe: React.FC<SvgIconDefaultProps> = ({ className, testId }) => {
  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M12.4126 3.58856L13.3437 5.78502C13.7494 6.74214 13.5246 7.86772 12.7869 8.56756L11.0471 10.2186C10.851 10.4049 10.7491 10.6752 10.793 10.9417C10.9609 11.9606 11.3331 12.9653 11.9094 13.9566C12.4846 14.9457 13.185 15.7874 14.0111 16.4813C14.2299 16.6649 14.5338 16.7126 14.8046 16.6221L16.8342 15.9451C17.7686 15.6336 18.7859 15.9916 19.3589 16.8334L20.6941 18.7948C21.3604 19.7736 21.2407 21.1234 20.4141 21.9532L19.5279 22.8426C18.6461 23.7277 17.3867 24.0489 16.2216 23.6855C13.471 22.8275 10.9425 20.2806 8.63502 16.0442C6.32427 11.8018 5.50906 8.20193 6.18886 5.24552C6.47486 4.00131 7.36048 3.0106 8.51694 2.64118L9.68315 2.26852C10.7773 1.92022 11.9446 2.48464 12.4126 3.58856Z"
        fill="#286AF6"
      />
    </CustomSvg>
  );
};

export default PhoneGe;
